const styles = {
  container: "flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8",
  logo: "mx-auto h-10 w-auto",
  title: "mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900",
  form: "mt-10 sm:mx-auto sm:w-full sm:max-w-sm space-y-6",
  label: "block text-sm font-medium leading-6 text-gray-900",
  input: "block w-full rounded-md border-0 py-1.5 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6",
  forgotPassword: "font-semibold text-indigo-600 hover:text-indigo-500",
  button: "flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600",
  signup: "mt-10 text-center text-sm text-gray-500",
  signupLink: "font-semibold leading-6 text-indigo-600 hover:text-indigo-500",
};

export default styles;